import { ReducerAction } from '@keplerco/core';
import { GetUserDto } from '../../../../../models/view/employee';

interface ManagePersonPermissionsState {
  person: GetUserDto | undefined;
}

export const initialState: ManagePersonPermissionsState = {
  person: undefined,
};

export enum ManagePersonPermissionsActionTypes {
  SetPerson = 0,
}

type ManagePersonPermissionsActions = ReducerAction<ManagePersonPermissionsActionTypes.SetPerson, { payload: GetUserDto | undefined }>;

export function reducer(state: ManagePersonPermissionsState, action: ManagePersonPermissionsActions): ManagePersonPermissionsState {
  if (action.type === ManagePersonPermissionsActionTypes.SetPerson) {
    return { ...state, person: action.payload };
  }
  return state;
}

